import React from 'react';
import PropTypes from 'prop-types';
import withRouter from "react-router-dom/withRouter";
import api from '../../services/api';
import {
    Button, Checkbox, FormControlLabel,
    IconButton, ListItemText,
    MenuItem, OutlinedInput,
    Paper, Select,
    Snackbar, Switch,
    TextField,
    Toolbar,
    Typography
} from '@material-ui/core';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import KVC from "../../services/KVC";

class CrackListExpansionListDetails extends React.Component {

    constructor(props) {
        super(props);
        let state = {
            packs: [],
            snackbarDisplayed: false,
            showLabelEditor: false,
        };
        if (props.match.url.includes("/create-list")) {
            state.list = {
                list_fr: '',
                list_en_GB: '',
                list_en: '',
                list_de: '',
                list_es: '',
                list_it: '',
                list_nl: '',
                pack_id: -1,
                card_index: 0,
            }
            state.$list = Object.assign({}, state.list);
        }
        this.state = state;
    }

    componentDidMount() {
        this.updateData();
    }

    updateData() {
        let requests = [
            api.getCrackListExpansionPacks()
        ];
        const listId = this.getListId();
        if (!!listId) {
            requests.push(api.getCrackListExpansionList(this.getListId()));
        }
        Promise.all(requests).then(results => {
            const packs = results[0];
            let state = {
                packs: packs,
                list: this.state.list,
            };
            if (results.length > 1) {
                const list = results[1];
                state = {
                    ...state,
                    list: list,
                    $list: Object.assign({}, list),
                };
            }
            this.setState(state)
        });
    }

    getListId() {
        return parseInt(this.props.match.params.listId, 10);
    }

    goBack = () => {
        if (this.props.history.length === 1) {
            this.props.history.push(`/${this.props.app.url_slug}/lists/`);
            return;
        }
        this.props.history.goBack();
    };

    listConfigIsPristine = () => {
        return JSON.stringify(this.state.list) === JSON.stringify(this.state.$list);
    };

    handleConfigValueChange = (propNamePath, type) => (e) => {
        if (type === 'number') {
            this.handleConfigChange(propNamePath, parseInt(e.target.value, 10));
        } else {
            this.handleConfigChange(propNamePath, e.target.value);
        }
    };

    handleConfigSwitchChange = (propNamePath) => (e, checked) => {
        this.handleConfigChange(propNamePath, checked ? 1 : 0);
    };

    handleConfigChange = (propNamePath, value) => {
        let list = Object.assign({}, this.state.list);
        KVC(list).setValueForKeyPath(propNamePath, value);
        this.setState({
            list: list,
        });
    };

    handlePackChange = (e) => {
        this.handleConfigChange('pack_id', e.target.value);
    }

    cancelEditingList = () => {
        this.setState({
            list: Object.assign(this.state.$list),
        });
    };

    commitEditingList = () => {
        const listId = this.getListId();
        if (!!listId) {
            api.patchCrackListExpansionList(listId, this.state.list).then(res => {
                if (res === undefined) {
                    this.displaySnackbar("Erreur lors de l'enregistrement de la liste.");
                    return;
                }
                this.displaySnackbar("Liste sauvegardée.");
                this.updateData();
            });
        } else {
            api.postCrackListExpansionList(this.state.list).then(res => {
                if (res === undefined) {
                    this.displaySnackbar("Erreur lors de l'enregistrement de la liste.");
                    return;
                }
                this.setState({
                    list: res,
                    $list: JSON.parse(JSON.stringify(res))
                });
                this.props.history.replace(`/${this.props.app.url_slug}/list/${res.list_id}`);
            });
        }
    };

    displaySnackbar(message) {
        this.setState({
            snackbarDisplayed: true,
            snackbarMessage: message,
        });
    }

    render() {

        if (this.state.list === undefined) {
            return <div/>;
        }

        const { packs, list } = this.state;

        return (
            <div className="wordsSearch">
                <Paper style={{marginBottom: 24}}>
                    <Toolbar>
                        <IconButton onClick={this.goBack} style={{marginLeft:-16}}>
                            <NavigateBeforeIcon/>
                        </IconButton>
                        <div style={{flex: 1}}>
                            <Typography variant="h6">{!this.getListId() ? "Nouvelle liste" : `Détails de la liste (ID : ${this.getListId()})`}</Typography>
                        </div>
                        {
                            this.listConfigIsPristine() ? null : (
                                <React.Fragment>
                                    <Button color="secondary" onClick={this.cancelEditingList}>
                                        Annuler
                                    </Button>
                                    <Button color="primary" onClick={this.commitEditingList}>
                                        Enregistrer
                                    </Button>
                                </React.Fragment>
                            )
                        }
                    </Toolbar>
                </Paper>

                {
                    list && packs ? (

                        <React.Fragment>
                            <Paper style={{padding: 24}}>
                                <div style={{display: 'flex'}}>

                                    <div style={{flex: 1}}>

                                        <div style={{marginBottom: 24}}>

                                            <TextField
                                                style={{marginRight: 12, width: 250}}
                                                select
                                                value={list.pack_id || -1}
                                                onChange={this.handlePackChange}
                                                label="Pack"
                                                SelectProps={{
                                                    displayEmpty: true
                                                }}
                                            >
                                                {
                                                    !list.pack_id ? <MenuItem value={-1} disabled>Sélectionner un pack</MenuItem> : null
                                                }
                                                {
                                                    packs.map((p, i) => <MenuItem key={i} value={p.pack_id}>{p.pack_fr}</MenuItem>)
                                                }
                                            </TextField>
                                        </div>

                                        <div style={{marginBottom: 32}}>
                                            <TextField
                                                onChange={this.handleConfigValueChange('card_index', 'number')}
                                                value={list.card_index}
                                                color="primary"
                                                label="N° carte"
                                                type="number"
                                                inputProps={{
                                                    style: {width: "200px"},
                                                    min: 1,
                                                    step: 1,
                                                }}
                                                style={{marginRight: 24}}
                                            />

                                        </div>

                                        <div style={{marginBottom: 32}}>

                                            <TextField
                                                style={{marginRight: 12, width: '100%'}}
                                                value={list.list_fr}
                                                onChange={this.handleConfigValueChange('list_fr')}
                                                label="Français"
                                            />

                                        </div>


                                        <div style={{marginBottom: 32}}>

                                            <TextField
                                                style={{marginRight: 12, width: '100%'}}
                                                value={list.list_en_GB}
                                                onChange={this.handleConfigValueChange('list_en_GB')}
                                                label="Anglais UK"
                                            />

                                        </div>


                                        <div style={{marginBottom: 32}}>

                                            <TextField
                                                style={{marginRight: 12, width: '100%'}}
                                                value={list.list_en}
                                                onChange={this.handleConfigValueChange('list_en')}
                                                label="Anglais US"
                                            />

                                        </div>

                                        <div style={{marginBottom: 32}}>

                                            <TextField
                                                style={{marginRight: 12, width: '100%'}}
                                                value={list.list_de}
                                                onChange={this.handleConfigValueChange('list_de')}
                                                label="Allemand"
                                            />

                                        </div>

                                        <div style={{marginBottom: 32}}>

                                            <TextField
                                                style={{marginRight: 12, width: '100%'}}
                                                value={list.list_es}
                                                onChange={this.handleConfigValueChange('list_es')}
                                                label="Espagnol"
                                            />

                                        </div>

                                        <div style={{marginBottom: 32}}>

                                            <TextField
                                                style={{marginRight: 12, width: '100%'}}
                                                value={list.list_it}
                                                onChange={this.handleConfigValueChange('list_it')}
                                                label="Italien"
                                            />

                                        </div>

                                        <div style={{marginBottom: 32}}>

                                            <TextField
                                                style={{marginRight: 12, width: '100%'}}
                                                value={list.list_nl}
                                                onChange={this.handleConfigValueChange('list_nl')}
                                                label="Néerlandais"
                                            />

                                        </div>

                                    </div>
                                </div>

                            </Paper>

                        </React.Fragment>

                    ) : null
                }


                <Snackbar
                    open={this.state.snackbarDisplayed}
                    message={this.state.snackbarMessage}
                    action={
                        <Button color="secondary" size="small" onClick={() => this.setState({snackbarDisplayed: false})}>
                            OK
                        </Button>
                    }
                    onClose={() => this.setState({snackbarDisplayed: false})}
                    autoHideDuration={3000}
                />

            </div>

        )
    }
}

CrackListExpansionListDetails.propTypes = {
    app: PropTypes.object.isRequired,
};

CrackListExpansionListDetails.defaultProps = {

};

export default withRouter(CrackListExpansionListDetails);